//
// locale_ro.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/ro.json';
import localeData from "react-intl/locale-data/ro.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
